// extracted by mini-css-extract-plugin
export var activeFilterButton = "_m2-c";
export var backButton = "_m2-4";
export var backIcon = "_m2-5";
export var chevronShortcut = "_m2-6";
export var container = "_m2-1";
export var editor = "_m2-8";
export var editorWrapper = "_m2-7";
export var prefix = "_m2-2";
export var searchIcon = "_m2-3";
export var suffix = "_m2-9";
export var suffixContent = "_m2-a";
export var suffixText = "_m2-b";
export var wrapper = "_m2-0";